import React from 'react';
import { Typography, Divider } from '@mui/material';

const Header = props => {
  const {
    text,
    subHeader,
    color = 'textPrimary',
    align = 'left'
  } = props;

  const dividerSx = color === 'inherit'
    ? { borderColor: 'rgba(255,255,255,0.35)' }
    : undefined;

  return (
    <>
      <Typography variant="h1" gutterBottom color={color} align={align}>
	{text}
      </Typography>
      {subHeader && (
	<Typography variant="body1" color={color} align={align} sx={{ opacity: color === 'inherit' ? 0.8 : 1 }}>
	  {subHeader}
	</Typography>
      )}
      <Divider sx={dividerSx} />
    </>
  )
}

export default Header;
